import {
    entityConfigToType,
    MutableEntityType,
} from 'app/agriculture/mutations/types/entityConfig';
import { useEntities } from 'app/agriculture/queries/entities/useEntities';

export function useEntity<T extends MutableEntityType>({
    entityId,
    entityType,
}: {
    entityId: string;
    entityType: T;
}): entityConfigToType[T] {
    const entities = useEntities(entityType);
    const entity = entities.get(entityId);
    if (!entity) throw new Error(`Could not find entity for id: ${entityId}`);

    return entity;
}
